import {Table} from 'reactstrap';
import React, { memo, useEffect, useMemo, useState } from 'react';

import { bidItemParamType, bidssummaryParamType } from '../../../../types/biddetail';
import { broadcasthistorySortFields, pageSize, sortDirections } from '../../../../utils/constants';
import {
  deprecatedGetDateTimeZoneConverted,
  Searchingfn,
  SortingFn,
} from '../../../../utils/helpers';
import { DeprecatedInput, Paging, Sort } from '../../../customcontrols';
import { addbidParamType } from '../../../../types/addbid';
import { loadingMsg } from '../../../../utils/texts';
import NoResult from '../../../customcontrols/noresult';
import { QuoteSummaryType } from '../../../../types/quotedetailstypedef';
import { sharedTypes } from '../../../../types/shared';
import SortingIcon from '../../../common/sortingIcon';
import { useAuthContext } from 'src/auth/AuthProvider';
import { Button } from 'antd';

const tdWidth = { width: '11.25rem' };

interface PropsTypes {
  getBidsBroadcastHistoryList?: any;
  getBidsBroadcastRecepients?: any;
  setBidSummaryDetails?: any;
  pagefor?: string;
  bidID?: number;
  quoteId?: any;
  bidssummary?: bidssummaryParamType;
  quoteSummary?: QuoteSummaryType;
  setSharedDetails?: any;
  shared?: sharedTypes;
  exportBroadcastRecepientList?: any;
  exportSupplementalSuppliers?: any;
  getAddBidsupplementalsuppliers?: any;
  addbid?: addbidParamType;
}

function BroadcastHistory(props: PropsTypes) {
  const {
    getBidsBroadcastHistoryList,
    getBidsBroadcastRecepients,
    setBidSummaryDetails,
    pagefor,
    bidID = '',
    quoteId = '',
    bidssummary,
    quoteSummary,
    setSharedDetails,
    shared,
    exportBroadcastRecepientList,
    exportSupplementalSuppliers,
    getAddBidsupplementalsuppliers,
    addbid,
  } = props;
  const { auth } = useAuthContext();
  const {
    broadcasthistory = [],
    recipients = [],
    currentbroadcast = '',
    stats,
    results,
  } = bidssummary || {};

  const { internalLoader } = shared || {};

  const {
    memberID: bidMemberId = '',
    tzfn: btzfn,
    tzn: btzn,
  } = (results as bidItemParamType) || {};
  const { broadcasts: bidBroadcasts, supplimentalSuppliers } = stats || {};
  const { statistics, summary } = quoteSummary || {};
  const { broadcasts: quoteBroadcasts } = statistics || {};
  const { memberId: quoteMemberId = '', tzfn: qtzfn, tzn: qtzn } = summary || {};
  const { supplementalsupplierlist = [] } = addbid || {};

  const pagetype = pagefor === 'addquotes' ? 'quote' : 'Bid';
  const id = pagetype === 'quote' ? quoteId : bidID;
  const tzfn = pagetype === 'quote' ? qtzfn : btzfn;
  const tzn = pagetype === 'quote' ? qtzn : btzn;

  const broadcasts = pagetype === 'quote' ? quoteBroadcasts : bidBroadcasts;
  const supplementalSuppliersCount =
    pagetype === 'quote' ? supplementalsupplierlist.length : supplimentalSuppliers;


  const [currentPage, setCurrentPage] = useState(1);
  const [currentPages, setCurrentPages] = useState(1);
  const listPerPage = pageSize.default;


  const [sortSuppliersvalue, setSortSuppliersvalue] = useState('date');
  const [sortSuppliers, setSortSuppliers] = useState(sortDirections.DESC);
  const [sortvalue, setSortvalue] = useState('name');
  const [sortorder, setSortorder] = useState(sortDirections.ASC);


  const [searchvalue, setSearchvalue] = useState('');


  useEffect(() => {
    if (pagetype === 'quote' && id) {
      getAddBidsupplementalsuppliers({ id, type: pagetype });
    }
  }, [id, pagetype,getAddBidsupplementalsuppliers]);

  useEffect(() => {
    if (id) {
      setSharedDetails({ internalLoader: true, showLoader: false });
      getBidsBroadcastHistoryList({ id, type: pagetype });
    }
  }, [id, pagetype,getBidsBroadcastHistoryList,setSharedDetails]);


  useEffect(() => {
    if (!currentbroadcast && broadcasthistory.length > 0 && id) {
      const first = broadcasthistory[0];

      setBidSummaryDetails({
        currentbroadcast: first,
        currentrecipients: [],
      });

      setSharedDetails({ internalLoader: true });

      getBidsBroadcastRecepients({
        id,
        type: pagetype,
        broadcastId: first.id,
      });
    }
  }, [broadcasthistory, currentbroadcast, id, pagetype,getBidsBroadcastRecepients,setBidSummaryDetails,setSharedDetails]);

  useEffect(() => {
    return () => {
      setBidSummaryDetails({ currentbroadcast: '', currentrecipients: [] });
    };
  }, [setBidSummaryDetails]);

  const sortedBroadcastHistory = useMemo(() => {
    return SortingFn(broadcasthistory, sortSuppliers, sortSuppliersvalue);
  }, [broadcasthistory, sortSuppliers, sortSuppliersvalue]);

  const pagedBroadcastHistory = useMemo(() => {
    const start = (currentPage - 1) * listPerPage;
    return sortedBroadcastHistory.slice(start, start + listPerPage);
  }, [sortedBroadcastHistory, currentPage,listPerPage]);

  const filteredRecipients = useMemo(() => {
    if (!searchvalue) return recipients;

    return Searchingfn(
      recipients,
      ['email', 'name', 'contact', 'status'],
      searchvalue.trimStart(),
    ) as any[];
  }, [recipients, searchvalue]);

  const sortedRecipients = useMemo(() => {
    return SortingFn(filteredRecipients, sortorder, sortvalue);
  }, [filteredRecipients, sortorder, sortvalue]);

  const pagedRecipients = useMemo(() => {
    const start = (currentPages - 1) * listPerPage;
    return sortedRecipients.slice(start, start + listPerPage);
  }, [sortedRecipients, currentPages,listPerPage]);

  const changeSortSelectBox = (_: string, value: any) => {
    if (value !== sortSuppliersvalue) {
      setSortSuppliersvalue(value);
    }
  };

  const changeSortOrder = () => {
    setSortSuppliers(
      sortSuppliers === sortDirections.DESC ? sortDirections.ASC : sortDirections.DESC,
    );
  };

  const changesearching = (_: string, search: any) => {
    setSearchvalue(search);
    setCurrentPages(1);
  };

  const handleExportClick = (e: any) => {
    e.preventDefault();
    exportBroadcastRecepientList({
      id,
      type: pagetype,
      broadcastId: currentbroadcast?.id,
      name:currentbroadcast?.name,
    });
  };


  return (
    <div className='row'>
      <div className='col-12'>
        <h3 className='mb-3 arrowWrapper'>Broadcast History</h3>
      </div>

      {sortedBroadcastHistory.length > 0 ? (
        <>
          <div className='col-lg-4'>
            <div className='ulListWrapper'>
              <h4>
                {sortedBroadcastHistory.length > 1 ? 'Broadcasts' : 'Broadcast'} (
                {sortedBroadcastHistory.length})
              </h4>

              <header className='headerFilter d-flex pl-0 align-items-center'>
                <Sort
                  sortFields={broadcasthistorySortFields}
                  selectedFieldName={sortSuppliersvalue}
                  onChange={changeSortSelectBox}
                  onSortClick={changeSortOrder}
                  sortIcon={sortSuppliers}
                />
              </header>

              <ul className='list-unstyled clearfix'>
                {pagedBroadcastHistory.map((item: any, index: number) => (
                  <li
                    key={index}
                    className={item.id === currentbroadcast?.id ? 'active' : ''}
                    onClick={() => {
                      if (item.id !== currentbroadcast?.id) {
                        setBidSummaryDetails({
                          currentbroadcast: item,
                          currentrecipients: [],
                        });

                        setSearchvalue('');
                        setCurrentPages(1);
                        setSortvalue('name');
                        setSortorder(sortDirections.ASC);
                        setSharedDetails({ internalLoader: true });
                        getBidsBroadcastRecepients({
                          id,
                          type: pagetype,
                          broadcastId: item.id,
                        });
                      }
                    }}
                  >
                    <h6 className='mw-100 text-truncate'>{item.name}</h6>
                    <span>
                      <i>Type :</i> {item.type}
                    </span>
                    <span>
                      <i>Date :</i> {deprecatedGetDateTimeZoneConverted(item.date, tzfn)} ({tzn})
                    </span>
                  </li>
                ))}
              </ul>

              <Paging
                totalRecords={sortedBroadcastHistory.length}
                currentPage={currentPage}
                onPagingClick={setCurrentPage}
                pageLimit={listPerPage}
              />
            </div>
          </div>

          <div className='col-lg-8 responsecontent'>
            <h4>Broadcast Details</h4>
            {((broadcasts && broadcasts > 0) || supplementalSuppliersCount > 0) &&
              (bidMemberId === auth?.memberId || quoteMemberId === auth?.memberId) && (
                  <Button onClick={handleExportClick} className='bttn bttn-secondary btnDropDown small float-right ml-3' disabled={internalLoader || !currentbroadcast||sortedRecipients.length === 0}>
                    Export
                  </Button>             
              )}

            {currentbroadcast ? (
              <div className='innerColIndent'>
                <Table borderless className='tableData'>
                  <tbody>
                    <tr>
                      <th style={tdWidth}>Broadcast Name</th>
                      <td>{currentbroadcast.name}</td>
                    </tr>
                    <tr>
                      <th>Type</th>
                      <td>{currentbroadcast.type}</td>
                    </tr>
                    <tr>
                      <th>Date</th>
                      <td>
                        {deprecatedGetDateTimeZoneConverted(currentbroadcast.date, tzfn)} ({tzn})
                      </td>
                    </tr>
                    <tr>
                      <th>Contact Name</th>
                      <td>{currentbroadcast.contact}</td>
                    </tr>
                    {currentbroadcast.declaredAttributes && (
                      <tr>
                        <th>Self Declarations</th>
                        <td>{currentbroadcast.declaredAttributes}</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            ) : (
              <NoResult message={internalLoader ? loadingMsg : 'No Details'} />
            )}

            <h4>Recipients ({sortedRecipients.length})</h4>
            {sortedRecipients.length > 0 && (
              <DeprecatedInput
                type='search'
                placeholder='Filter'
                label='Filter'
                value={searchvalue}
                handleChange={changesearching}
                parentClass='w-50'
              />
            )}

            {pagedRecipients.length > 0 ? (
              <div className='innerColIndent'>
                <Table className='tableHData'>
                  <tbody>
                    <tr>
                      <th>
                        Supplier Name
                        <SortingIcon
                          sortlist={sortedRecipients}
                          initialsortorder={sortorder}
                          currentsortname={sortvalue}
                          changesortname={setSortvalue}
                          sortname='name'
                          changeSortingFn={() =>
                            setSortorder(
                              sortorder === sortDirections.ASC
                                ? sortDirections.DESC
                                : sortDirections.ASC,
                            )
                          }
                        />
                      </th>
                      <th>Contact</th>
                      <th>
                        Email
                        <SortingIcon
                          sortlist={sortedRecipients}
                          initialsortorder={sortorder}
                          currentsortname={sortvalue}
                          changesortname={setSortvalue}
                          sortname='email'
                          changeSortingFn={() =>
                            setSortorder(
                              sortorder === sortDirections.ASC
                                ? sortDirections.DESC
                                : sortDirections.ASC,
                            )
                          }
                        />
                      </th>
                      <th>Status</th>
                    </tr>
                    {
                    internalLoader ? (
                      <NoResult message={internalLoader ? loadingMsg : 'No Recipients Available'} />
                    ) : (pagedRecipients.map((item: any, i: number) => (
                      <tr key={i}>
                        <td>{item.name}</td>
                        <td>{item.contact}</td>
                        <td>{item.email}</td>
                        <td>{item.status}</td>
                      </tr>
                    )))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <NoResult message={internalLoader ? loadingMsg : 'No Recipients Available'} />
            )}

            <Paging
              totalRecords={sortedRecipients.length}
              currentPage={currentPages}
              onPagingClick={setCurrentPages}
              pageLimit={listPerPage}
            />
          </div>
        </>
      ) : (
        <NoResult message={internalLoader ? loadingMsg : 'No Broadcasts Available'} />
      )}
    </div>
  );
}

export default memo(BroadcastHistory);
